import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCallMade = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_5432_585",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 16,
			height: 16,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_5432_585)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M3.74667 13L3 12.2533L9.18667 6.06667H5.66667V5H11V10.3333H9.93333V6.81333L3.74667 13Z",
				fill: "#0F3549"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCallMade);
export { ForwardRef as ReactComponent };
